import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Segment } from '../types/segment.type';
import { ADMIN_SEGMENTS_API_PATHS } from '../constants/segments-api-paths.constants';

type UseRestoreSegmentResult = {
  restoreSegment: (segmentId: string) => Promise<Segment | null>;
  isSubmitting: boolean;
};

export function useRestoreSegment(): UseRestoreSegmentResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreSegment = async (segmentId: string): Promise<Segment | null> => {
    setIsSubmitting(true);

    try {
      const restoredSegment = await HttpClient.post<Segment>(ADMIN_SEGMENTS_API_PATHS.RESTORE_SEGMENT(segmentId));

      enqueueSnackbar('Segment restauré', { variant: 'success' });
      return restoredSegment;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la restauration du segment'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreSegment, isSubmitting };
}
